var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.1127 6.76875V17.2313H8.04395V6.76875H6.1127ZM4.7627 6.75C4.7627 6.01477 5.35872 5.41875 6.09395 5.41875H8.0627C8.79792 5.41875 9.39395 6.01477 9.39395 6.75V17.25C9.39395 17.9852 8.79792 18.5813 8.0627 18.5813H6.09395C5.35872 18.5813 4.7627 17.9852 4.7627 17.25V6.75Z",
    fill: "#383733"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9564 6.76875V17.2313H17.8877V6.76875H15.9564ZM14.6064 6.75C14.6064 6.01477 15.2025 5.41875 15.9377 5.41875H17.9064C18.6417 5.41875 19.2377 6.01477 19.2377 6.75V17.25C19.2377 17.9852 18.6417 18.5813 17.9064 18.5813H15.9377C15.2025 18.5813 14.6064 17.9852 14.6064 17.25V6.75Z",
    fill: "#383733"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8877 8.0625C17.8877 7.68971 18.1899 7.3875 18.5627 7.3875H20.5314C20.8845 7.3875 21.2231 7.52776 21.4728 7.77742C21.7224 8.02707 21.8627 8.36568 21.8627 8.71875V15.2813C21.8627 15.6343 21.7224 15.9729 21.4728 16.2226C21.2231 16.4722 20.8845 16.6125 20.5314 16.6125H18.5627C18.1899 16.6125 17.8877 16.3103 17.8877 15.9375C17.8877 15.5647 18.1899 15.2625 18.5627 15.2625H20.5127V8.7375H18.5627C18.1899 8.7375 17.8877 8.43529 17.8877 8.0625Z",
    fill: "#383733"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.4877 8.7375H5.4377C5.81049 8.7375 6.1127 8.43529 6.1127 8.0625C6.1127 7.68971 5.81049 7.3875 5.4377 7.3875H3.46895C3.11588 7.3875 2.77727 7.52776 2.52761 7.77742C2.27795 8.02707 2.1377 8.36568 2.1377 8.71875V15.2813C2.1377 15.6343 2.27795 15.9729 2.52761 16.2226C2.77727 16.4722 3.11588 16.6125 3.46895 16.6125H5.4377C5.81049 16.6125 6.1127 16.3103 6.1127 15.9375C6.1127 15.5647 5.81049 15.2625 5.4377 15.2625H3.4877V8.7375Z",
    fill: "#383733"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.04395 12C8.04395 11.6272 8.34615 11.325 8.71895 11.325H15.2814C15.6542 11.325 15.9564 11.6272 15.9564 12C15.9564 12.3728 15.6542 12.675 15.2814 12.675H8.71895C8.34615 12.675 8.04395 12.3728 8.04395 12Z",
    fill: "#383733"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSport);
export default __webpack_public_path__ + "static/media/sport.21847f1faf92f44de0d482e167b3cd1b.svg";
export { ForwardRef as ReactComponent };